import React, { Component } from 'react';
import BaseRefer from './BaseRefer';
import DropDownRefer from './DropDownRefer';
import PopRefer from './PopRefer';
import ReferWithUnit from './ReferWithUnit';
import ArrayTree from './components/ArrayTree';
import MultiLangWrapper from './MultiLangWrapper';
import ReferLoader from './ReferLoader';

require('./index.less');

class Refer extends Component {
	render() {
		const { refType, type, unitProps } = this.props;
		if (type === 'dropDown' && refType === 'grid') {
			return <DropDownRefer {...this.props} />;
		} else if (unitProps) {
			return <ReferWithUnit {...this.props} />;
		} else {
			return <PopRefer {...this.props} />;
		}
	}
}

Refer = MultiLangWrapper(Refer);

Refer.BaseRefer = BaseRefer;
Refer.DropDownRefer = DropDownRefer;
Refer.PopRefer = PopRefer;
Refer.ArrayTree = ArrayTree;
Refer.ReferWithUnit = ReferWithUnit;
Refer.MultiLangWrapper = MultiLangWrapper;
Refer.ReferLoader = ReferLoader;

export default Refer;
